var _path, _rect, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58271 4.72055C4.35171 6.37026 3.03617 8.59764 3.03617 11.0002C3.03617 13.4027 4.35171 15.6301 6.58271 17.2798C8.81356 18.9294 11.926 19.969 15.3919 19.969C18.8579 19.969 21.9703 18.9294 24.2012 17.2798C26.4322 15.6301 27.7477 13.4027 27.7477 11.0002C27.7477 8.59764 26.4322 6.37026 24.2012 4.72055C21.9703 3.07096 18.8579 2.03128 15.3919 2.03128C11.926 2.03128 8.81356 3.07096 6.58271 4.72055ZM5.81801 3.6864C8.29183 1.85715 11.6788 0.745117 15.3919 0.745117C19.1051 0.745117 22.4921 1.85715 24.9659 3.6864C27.4395 5.51554 29.0339 8.09414 29.0339 11.0002C29.0339 13.9062 27.4395 16.4848 24.9659 18.3139C22.4921 20.1432 19.1051 21.2552 15.3919 21.2552C11.6788 21.2552 8.29183 20.1432 5.81801 18.3139C3.34435 16.4848 1.75 13.9062 1.75 11.0002C1.75 8.09414 3.34435 5.51554 5.81801 3.6864Z",
    fill: "url(#paint0_linear_5580_23088)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.745117,
    width: 22.8732,
    height: 15.1446,
    rx: 2,
    fill: "url(#paint1_linear_5580_23088)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4371 13.2111C15.0931 13.2111 18.0568 11.0195 18.0568 8.31613C18.0568 5.61274 15.0931 3.4212 11.4371 3.4212C7.78113 3.4212 4.81738 5.61274 4.81738 8.31613C4.81738 11.0195 7.78113 13.2111 11.4371 13.2111Z",
    fill: "#1A2037"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5580_23088",
    x1: 23.9326,
    y1: 2.46048,
    x2: 6.85227,
    y2: 19.5408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A2037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#976CF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5580_23088",
    x1: 1.75434e-7,
    y1: 2.00281,
    x2: 51.2389,
    y2: 35.8346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386317,
    stopColor: "#00BFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2037"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d253c07a5ed23a37a297d1e8f5e6e647.svg";
export { ForwardRef as ReactComponent };